import { formButtonWidgetConfig, inputWidgetConfig } from '@finxone-platform/shared/workflow-mapping';
import { FormID } from '@finxone-platform/form-action';
import { cryptoRandomUUID } from '@finxone-platform/shared/sys-config-types';
import { newSupportChatChildComponents } from './new-support-chat.constants';
import { spendingBudgetChildComponents } from './spending-budget-form.consts';
import { saveTransactionNoteFormChildComponents } from './save-transaction-note-form.constant';
import { depositFormChildComponents, pispRecurringDepositFormChildComponents } from './deposit-form.consts';

export const defaultInputWidgetConfig = [
  {
    ...inputWidgetConfig,
    widgetConfiguration: {
      ...inputWidgetConfig.widgetConfiguration,
      attributes: {
        ...inputWidgetConfig.widgetConfiguration.attributes,
        widgetProperties: {
          ...inputWidgetConfig.widgetConfiguration.attributes.widgetProperties,
          inputFieldConfig: {
            id: 'input-1',
            type: 'text',
            label: 'Input 1',
            parentForm: '',
            name: 'input-1',
            validation: {
              required: true,
            },
          },
        },
      },
    },
  },
  {
    ...formButtonWidgetConfig,
  },
];

export const accountNameInputWidgetConfig = [
  {
    ...inputWidgetConfig,
    widgetConfiguration: {
      ...inputWidgetConfig.widgetConfiguration,
      attributes: {
        ...inputWidgetConfig.widgetConfiguration.attributes,
        widgetProperties: {
          ...inputWidgetConfig.widgetConfiguration.attributes.widgetProperties,
          inputFieldConfig: {
            id: 'account-name-input',
            type: 'text',
            label: 'Account Name',
            parentForm: FormID.ACCOUNT_NAME_FORM,
            name: 'account-name-input',
            validation: {
              required: true,
            },
          },
        },
      },
    },
  },
  {
    widgetTypeConfig: 'new',
    uniqueId: cryptoRandomUUID().toString(),
    name: 'action_button_widget',
    widgetConfiguration: {
      widgetDisplayName: 'Action Button Widget',
      widgetConfigDisplayName: 'Action Button',
      isRemovable: true,
      attributes: {
        elementsConfig: [],
        label: '',
        sub_heading: '',
        show: true,
        css_config: {
          iconUnit: 'px',
          leftIconUnit: 'px',
          rightIconUnit: 'px',
        },
        widgetProperties: {
          textContent: 'Change Account Name',
          buttonActionType: 'change-account-nickname',
          zoneToNavigate: 'beneficiary_zone',
          urlToNavigate: 'beneficiary-list',
          globalStyling: true,
          globalStylingClass: 'primaryButton full-width',
          dataContext: 'current-account',
          successAlertType: null,
          errorAlertType: null,
          actionNavigationConfigurations: {},
          icon: '',
          righticon: '',
        },
        iconConfig: {
          rightIcon: '',
          leftIcon: '',
        },
      },
    },
    gridPosition: {
      x: 0,
      y: 0,
      minItemCols: 1,
      minItemRows: 1,
      rows: 3,
      cols: 15,
      resizeEnabled: true,
      dragEnabled: true,
    },
    widgetIconPath: 'generic-widget',
  },
];

// Map predefined FormID values to arrays of child component configs.
// Add entries here as new predefined forms are introduced.
// Use string keys so lookup from formConfigData.id is straightforward.
export const predefinedFormChildComponents: Record<string, any[]> = {
  // Example mapping: ONBOARDING_FLOW uses the default single input widget for now.
  [FormID.ONBOARDING_FLOW]: defaultInputWidgetConfig,
  [FormID.ACCOUNT_NAME_FORM]: accountNameInputWidgetConfig,
  [FormID.NEW_SUPPORT_CHAT_FORM]: newSupportChatChildComponents,
  [FormID.SPENDING_BUDGET_FORM]: spendingBudgetChildComponents,
  [FormID.SAVE_TRANSACTION_NOTE_FORM]: saveTransactionNoteFormChildComponents,
  [FormID.DEPOSIT_FORM]: depositFormChildComponents,
  [FormID.PISP_RECURRING_DEPOSIT_FORM]: pispRecurringDepositFormChildComponents,

  // future entries:
  // [FormID.BENEFICIARY_FORM]: beneficiaryFormChildComponents,
  // [FormID.VERIFICATION_FORM]: verificationFormChildComponents,
};
